import React, { useEffect, useState } from "react";

import Box from "@mui/material/Box";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";

import FormInfoSolicitud from "../components/FormInfoSolicitud";
import FormInformacionCliente from "../../app-cliente/components/FormInformacionCliente";
import FormInformacionUbicabilidad from "../../app-cliente/components/FormInformacionUbicabilidad";

import "../styles/main.css";
import { useSelector } from "react-redux";

import FormClienteReferencias from "app/modules/app-cliente/components/FormClienteReferencias";
import {
  LooksOneOutlined,
  LooksTwoOutlined,
  Looks3Outlined,
  Looks4Outlined,
} from "@mui/icons-material";

import TabFirmaFotoCliente from "./tabFirmaFotoCliente";
import BoxGenerarLinkFirma from "../components/BoxGenerarLinkFirma";
import {
  obtenerParametro,
  obtenerRegistroGrupo,
} from "app/modules/app-configuracion/services/configuracionServices";
import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Stack,
} from "@mui/material";
import FormClienteActividadEconomica from "app/modules/app-cliente/components/FormClienteActividadEconomica";
import FormInformacionConyugue from "app/modules/app-cliente/components/FormInformacionConyugue";
import BoxDocumentosCliente from "../components/BoxDocumentosCliente";
import {
  consultaClienteXidCliente,
  consultaContacto,
  consultaEstFinanciero,
  consultarInformacionDemograficaIdentificacion,
  crearClienteContacto,
  crearClienteEstadoFinanciero,
  grabarClienteOrquestacion,
  obtenerRegistroArchivo,
  obtenerRegistroFirma,
} from "app/modules/app-cliente/services/clienteService";
import { SCSGenericButton } from "app/modules/common/components/Buttons/SCSButtons";
import { red } from "@mui/material/colors";
import {
  grabarRegistroCLiente,
  obtenerRegistroCliente,
} from "app/modules/app-authcli/services";
import FormDebitoCuenta from "../components/FormDebitoCuenta";
import FormContactoCliente from "app/modules/app-cliente/components/FormContactoCliente";
import { useHistory } from "react-router-dom";
import { consultarFechaSistema } from "app/modules/shared/services/sheredServices";
import { set } from "date-fns";
import { obtenerPreevaluacion } from "../services/creditoServices";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const StepInformacionCredito = ({
  identificacion,
  idCli,
  clienteConsultado,
  flujoFinal,
  cambioCupo,
  datosPreevaluacion,
}) => {
  const [value, setValue] = useState(0);
  const [valueCli, setValueCli] = useState(0);
  const [activeStep, setActiveStep] = useState(0);
  const [skipped, setSkipped] = useState(new Set());
  /* const [idCliente, setIdCliente] = useState(idCli); */
  const [generaLink, setGeneraLink] = useState(false);
  const [idSolicitud, setIdSolicitud] = useState(-1);
  const [actividadEconomica, setActividadEconomica] = useState(null);

  const [validarConyugue, setValidarConyugue] = useState(false);

  const [idClienteInformacion, setIdClienteInformacion] = useState(-1);
  const [idClienteAux, setIdClienteAux] = useState(null);
  const { authUser } = useSelector(({ auth }) => auth);
  const [archivoFirmaFoto, setArchivoFirmaFoto] = useState(null);
  const [registroFirmaFoto, setRegistroFirmaFoto] = useState(null);
  const [habilitarSiguiente, setHabilitarSiguiente] = useState(false);
  const [esRegistro, setEsRegistro] = useState(false);
  const [tieneContacto, setTieneContacto] = useState(false);
  const [openImagenFinal, setOpenImagenFinal] = useState(false);
  const [usaDebitoCuenta, setUsaDebitoCuenta] = useState(false);
  const [idClienteCreado, setIdClienteCreado] = useState(0);

  const history = useHistory();

  const [infoGrabada, setInfoGrabada] = useState({
    cliente: false,
    firma: false,
    financiero: false,
    solicitud: false,
  });

  //****DEBE ESTAR ORDENADO SEGUN LAS TABS PARA VALIDAR BOTON CONTINUAR */
  const [infoClienteGrabada, setInfoClienteGrabada] = useState({
    infoCliente: false,
    ubicabilidad: false,
    firma: false,
    financiero: false,
    referencias: false,
  });

  let today = null;

  useEffect(async () => {
    //console.log();
    //console.log(idCli);

    //setIdClienteAux(idCli);
    getFecha();
    const idclient = await handleCrearContactoCliente();
    getRolTablet();
    if (flujoFinal === "EXPRESS") {
      await handleGrabarDatosExpress(idclient);
    }
    //getArchivosFirmaFoto(idCli);
  }, []);

  useEffect(async () => {
    //console.log(infoClienteGrabada);
    const indice = Object.values(infoClienteGrabada).lastIndexOf(true);
    //console.log(indice);
    if (indice >= 0) grabarInfoIngresada(indice);

    if (infoClienteGrabada.infoCliente) {
      await verificarTipoDocumento();
    }

    if (infoClienteGrabada.infoCliente && infoClienteGrabada.ubicabilidad) {
      //console.log("Entra a cambiar estado CLIENTE");
      setInfoGrabada((args) => ({
        ...args,
        cliente: true,
      }));
      //await validarPasoGrabado(valueCli)
      //setHabilitarSiguiente(true);
    }

    if (infoClienteGrabada.firma) {
      //console.log("Entra a cambiar estado FIRMA");
      setInfoGrabada((args) => ({
        ...args,
        firma: true,
      }));
    }

    if (infoClienteGrabada.financiero && infoClienteGrabada.referencias) {
      //console.log("Entra a cambiar estado FINANCIERO");
      setInfoGrabada((args) => ({
        ...args,
        financiero: true,
      }));
    }

    if (!infoGrabada.firma && cambioCupo) {
      setInfoGrabada((args) => ({
        ...args,
        financiero: false,
      }));
    }
  }, [infoClienteGrabada]);

  useEffect(() => {
    validarPasoGrabado(valueCli);
    //console.log(infoGrabada);
  }, [valueCli, infoGrabada]);

  useEffect(async () => {
    if (infoGrabada.solicitud) {
      try {
        //const today = new Date().toLocaleString("en-US");
        const srvRegistroCliente = await obtenerRegistroCliente(
          identificacion,
          authUser.usuarioFlujos[0].idGrupo
        );
        if (srvRegistroCliente.state) {
          let registro = srvRegistroCliente.data;

          //debugger;
          registro.secuencia = 6;
          registro.procesado = true;
          registro.usuarioModificacion = authUser.key;
          // registro.usuario = registro.usuario.replace("registro", "cliente");
          registro.estacionModificacion = authUser.estacion;
          registro.fechaModificacion = today;

          try {
            var srvGrabarRegistro = await grabarRegistroCLiente(registro);
          } catch (e) {
            console.log(e);
          }
        } else {
          //No existe registro de Prospeccion
          setEsRegistro(false);
          console.log(srvRegistroCliente.message);
        }
      } catch (e) {
        console.log(e.message);
      }
    }
  }, [infoGrabada.solicitud]);

  useEffect(() => {
    setIdClienteInformacion(idClienteAux);
    if (idClienteInformacion > 0) {
      setIdClienteInformacion(idClienteInformacion);
      setIdClienteAux(idClienteInformacion);
    }
  }, [idClienteInformacion]);

  const getFecha = async () => {
    const srvFecha = await consultarFechaSistema();
    //debugger;
    if (srvFecha.state) {
      today = srvFecha.data.fechaHora;
    } else {
      today = new Date().toLocaleString("en-US");
    }
    //console.log(today);
  };
  const handleGrabarDatosExpress = async (idClienteGrabar) => {
    setValueCli(1);

    setInfoClienteGrabada((args) => ({
      ...args,
      infoCliente: true,
      ubicabilidad: true,
      referencias: true,
    }));

    setInfoGrabada((args) => ({
      ...args,
      cliente: true,
    }));

    if (!cambioCupo) {
      setInfoClienteGrabada((args) => ({
        ...args,
        financiero: true,
        referencias: true,
      }));
    }

    //Grabar estado financiero
    if (!cambioCupo) {
      let info;
      try {
        const respPreevaluacion = await obtenerPreevaluacion(
          identificacion,
          authUser.usuarioFlujos[0].idGrupo
        );
        if (respPreevaluacion.state) {
          info = respPreevaluacion.data;
          console.log({ info });
        } else {
          console.log(respPreevaluacion.message);
        }
      } catch (_errors) {
        console.log(_errors);
      }

      let infoEstadoFinanciero;

      try {
        const informacionEstadoFinanciero = await consultaEstFinanciero(
          idClienteGrabar
        );

        if (informacionEstadoFinanciero.state) {
          infoEstadoFinanciero = informacionEstadoFinanciero.data;
        } else {
        }
      } catch (error) {
        console.log(error);
      }

      const informacionEstadoFinanciero = {
        idCliente: idClienteGrabar,
        idEstadoFinanciero: infoEstadoFinanciero?.idEstadoFinanciero | 0,
        origenIngresos:
          info.actividadLab === "DEPENDIENTE" ? "AECDEP" : "AECIND",
        actividadEconomica: "",
        ingresoMensual: info.valorIngresos,
        comision: 0,
        renta: 0,
        remesa: 0,
        ventas: 0,
        otrosIngresos: 0,
        totalIngresos: info.valorIngresos,
        detalleOtrosIngresos: "",
        profesion: "",
        esActivo: true,
        fechaCreacion: today,
        usuarioCreacion: authUser.key,
        estacionCreacion: authUser.estacion,
      };

      try {
        const respuestaClienteInformacion = await crearClienteEstadoFinanciero(
          informacionEstadoFinanciero
        );

        if (respuestaClienteInformacion.state) {
        } else {
          alert(`${respuestaClienteInformacion.message}`);
        }
      } catch (error) {
        alert(`${error.response.data.message}`);
        console.log(error);
      } finally {
      }
    }
  };

  const getPreevaluacion = async () => {};

  const verificarTipoDocumento = async () => {
    try {
      const srvCliente = await consultaClienteXidCliente(idClienteAux);
      //console.log(srvCliente);

      if (srvCliente.state) {
        const datosCli = srvCliente.data;

        if (srvCliente.data.tipoIdentificacion !== "CI") {
          alert(
            "No puede ingresar una solicitud con el tipo de documento ingresado"
          );
          history.push("/initialHome");
        }
      } else {
        console.log(srvCliente.message);
      }
    } catch (e) {
      console.log(e);
    }
  };
  const grabarInfoIngresada = async (paso) => {
    //debugger;
    const arrayEstados = Object.values(infoClienteGrabada);
    if (arrayEstados[paso]) {
      try {
        //const today = new Date().toLocaleString("en-US");
        const srvRegistroCliente = await obtenerRegistroCliente(
          identificacion,
          authUser.usuarioFlujos[0].idGrupo
        );
        if (srvRegistroCliente.state) {
          setEsRegistro(true);
          let registro = srvRegistroCliente.data;
          if (paso + 1 > registro.secuencia && registro.secuencia < 6) {
            registro.secuencia = paso + 1;
          }
          registro.usuarioModificacion = authUser.key;
          registro.estacionModificacion = authUser.estacion;
          registro.fechaModificacion = today;
          registro.idCliente = idClienteInformacion;
          registro.idFlujo = authUser.usuarioFlujos[0].idFlujo;
          try {
            var srvGrabarRegistro = await grabarRegistroCLiente(registro);
          } catch (e) {
            //console.log(e);
          }
        } else {
          //no existe registro de prospeccion
          //console.log(srvRegistroCliente.message);
        }
      } catch (e) {
        //console.log(e.message);
      }
    }
  };

  const validarPasoGrabado = async (paso) => {
    //console.log(valueCli);
    const arrayDatosGrabados = Object.values(infoGrabada);
    //console.log(paso);
    setHabilitarSiguiente(arrayDatosGrabados[paso]);
  };

  const getRolTablet = async () => {
    try {
      const response = await obtenerParametro("ROLTAB");
      if (response.state) {
        const idRol = authUser.usuarioRol[0].idRol;
        idRol === response.data ? setGeneraLink(false) : setGeneraLink(true);

        //console.log(response.data);
      } else {
        console.log("Error al obtener rol que genera link de firma", response);
      }
    } catch (_errors) {
      console.log(_errors);
    }
  };

  const getArchivosFirmaFoto = async (idCliente) => {
    setArchivoFirmaFoto(false);
    let infoArchivos;
    try {
      const fotos = await obtenerRegistroArchivo(idCliente);
      if (fotos.state) {
        infoArchivos = fotos.data;
        //setArchivoFirmaFoto(true);
        console.log("Si existe registro de Foto");
        //console.log(fotos.data);
      } else {
        console.log("No existe registro de Foto");
        //setArchivoFirmaFoto(null);
      }
    } catch (_errors) {
      console.log(_errors);
    }

    let infofirma;
    try {
      const firma = await obtenerRegistroFirma(idCliente);
      if (firma.state) {
        infofirma = firma.data;
        //setArchivoFirmaFoto(true);
        console.log("Si existe registro de firma");
        //console.log(solicit.firma);
      } else {
        console.log("No existe registro de firma");
        //setArchivoFirmaFoto(null);
      }
    } catch (_errors) {
      console.log(_errors);
    }

    if (infoArchivos.idArchivo && infofirma.idFirma) {
      const res = {
        ...infoArchivos,
        ...infofirma,
      };

      setRegistroFirmaFoto(res);
      setArchivoFirmaFoto(true);
    } else {
      setRegistroFirmaFoto(null);
      setArchivoFirmaFoto(false);
      //setMostrarMensajeDocs(true);
    }
  };

  const handleChangeTabCli = (event, newValue) => {
    setValueCli(newValue);
  };

  const handleSeeDocs = async () => {
    try {
      await getArchivosFirmaFoto(idClienteInformacion);
    } catch (e) {
      setInfoGrabada((args) => ({
        ...args,
        firma: false,
        financiero: false,
      }));
      setInfoClienteGrabada((args) => ({
        ...args,
        firma: false,
        financiero: false,
      }));
      alert("No existen completos los documentos de firma y foto");
    }
  };

  const handleCrearContactoCliente = async () => {
    try {
      const srvObtenerDemografica =
        await consultarInformacionDemograficaIdentificacion(
          identificacion,
          authUser.usuarioFlujos[0].idGrupo
        );
      if (srvObtenerDemografica.state) {
        const clienteInfo = srvObtenerDemografica.data;

        const informacionCliente = {
          idCliente: Number(
            `${clienteInfo.idCliente <= 0 ? 0 : clienteInfo.idCliente}`
          ),
          idGrupo: 1,
          identificacion: identificacion,
          tipoIdentificacion: clienteInfo.tipoIdentificacion || "CI",
          naturaleza: clienteInfo.naturaleza ?? "PERS01",

          perfilRiesgo: clienteInfo.perfilRiesgo ?? "",
          tipoCliente: clienteInfo.tipoCliente ?? "",
          score: clienteInfo.score ?? 0,
          origen: clienteInfo.origen ?? "",
          actualizado: clienteInfo.actualizado ?? false,
          esActivo: true,

          fechaCreacion: today,
          usuarioCreacion: authUser.key,
          estacionCreacion: authUser.estacion,
        };

        //console.log({ informacionCliente });

        const informacionDemografica = {
          primerNombre: clienteInfo.primerNombre.toUpperCase().trim(),
          primerApellido: clienteInfo.primerApellido.toUpperCase().trim(),
          segundoNombre: clienteInfo.segundoNombre.toUpperCase().trim(),
          segundoApellido: clienteInfo.segundoApellido.toUpperCase().trim(),
          estadoCivil: clienteInfo.estadoCivil,
          fechaNacimiento: clienteInfo.fechaNacimiento,
          genero: clienteInfo.genero,
          nacionalidad: clienteInfo.nacionalidad,
          nivelInstruccion: clienteInfo.nivelInstruccion,
          razonSocial: clienteInfo.razonSocial.toUpperCase(),
          nombreComercial: clienteInfo.nombreComercial.toUpperCase().trim(),
          codigoDactilar: clienteInfo.codigoDactilar.toUpperCase().trim(),
          fechaIdentificacion: clienteInfo.fechaIdentificacion,
          esFallecido: clienteInfo.esFallecido ?? false,
          esActivo: true,

          fechaCreacion: today,
          usuarioCreacion: authUser.key,
          estacionCreacion: authUser.estacion,
        };

        const informacionOrquestacion = {
          cliente: { ...informacionCliente },
          demografica: { ...informacionDemografica },
        };

        //console.log(informacionOrquestacion);

        try {
          const respuestaClienteOrquestacion = await grabarClienteOrquestacion(
            informacionOrquestacion
          );

          if (respuestaClienteOrquestacion.state) {
            const idCliente = respuestaClienteOrquestacion.data;
            setIdClienteCreado(idCliente);
            setIdClienteInformacion(idCliente);
            setIdClienteAux(idCliente);

            let datosContacto;
            const srvObtenerContacto = await consultaContacto(respuestaClienteOrquestacion.data, "DIRDOM");
            if (srvObtenerContacto.state) {
              datosContacto = srvObtenerContacto.data;
              setTieneContacto(true);
            } else {
              //alert("Debe grabar los datos de contacto.");
              console.log(srvObtenerContacto.message);
            }

            const informacionContacto = {
              idCliente: idCliente,
              idContacto: datosContacto?.idContacto | 0,
              celular: datosPreevaluacion.datosPreevaluacion.celular,
              email: datosPreevaluacion.datosPreevaluacion.email,
              tipoDireccion: "DIRDOM",
              preferencia: "EMAIL",
              esPersonal: true,
              esActivo: true,
              fechaCreacion: today,
              usuarioCreacion: authUser.key,
              estacionCreacion: authUser.estacion,
            };

            console.log(informacionContacto);

            try {
              const respuestaClienteContacto = await crearClienteContacto(
                informacionContacto
              );

              if (respuestaClienteContacto.state) {
                setTieneContacto(true);
                return idCliente;
              } else {
                alert(`${respuestaClienteContacto.message}`);
                return idCliente;
              }
            } catch (error) {
              alert(`${error?.response?.data?.message}`);
              console.log(error);
              return idCliente;
            }
          } else {
            alert(`${respuestaClienteOrquestacion.message}`);
            return 0;
          }
        } catch (error) {
          alert(`${error.response.data.title}`);
          return 0;
        }
      } else {
        console.log(srvObtenerDemografica.message);
        return 0;
      }
    } catch (e) {
      return 0;
    }
  };

  const handleCloseImagenFinal = async () => {
    setOpenImagenFinal(false);
    const path = "/initialHome";
    history.push(path);
    //
  };

  return (
    <>
      {idClienteAux && (
        <div>
          <Stack direction="row" justifyContent="flex-end">
            <SCSGenericButton
              size={18}
              titulo="Siguiente -->>"
              onClick={() => {
                if (flujoFinal === "EXPRESS" && !cambioCupo) {
                  setValueCli(valueCli + 2);
                } else {
                  setValueCli(valueCli + 1);
                }
                //console.log("OK");
              }}
              //  hidden={valueCli===5?true:false}
              disabled={!habilitarSiguiente}
            />
          </Stack>
          <Stack direction="row" justifyContent="center">
            <Tabs
              //variant="fullWidth"

              value={valueCli}
              onChange={handleChangeTabCli}
              //aria-label="icon label tabs example"
              textColor="error"
              variant="scrollable"
              scrollButtons="auto"
            >
              {flujoFinal !== "EXPRESS" && (
                <Tab
                  icon={<LooksOneOutlined />}
                  iconPosition="start"
                  label="Datos Personales"
                  className="tabsAnalista"
                  value={0}
                />
              )}
              <Tab
                icon={<LooksTwoOutlined />}
                iconPosition="start"
                label="Documentos"
                className="tabsAnalista"
                value={1}
              />
              {(flujoFinal !== "EXPRESS" || cambioCupo) && (
                <Tab
                  icon={<Looks3Outlined />}
                  iconPosition="start"
                  label="Informacion Financiera"
                  className="tabsAnalista"
                  value={2}
                />
              )}

              <Tab
                icon={<Looks4Outlined />}
                iconPosition="start"
                label="Solicitud"
                className="tabsAnalista"
                value={3}
              />
            </Tabs>
          </Stack>
          {flujoFinal !== "EXPRESS" && (
            <TabPanel value={valueCli} index={0}>
              <FormInformacionCliente
                idCliente={idClienteAux}
                identificacion={identificacion}
                setIdClienteInformacion={setIdClienteInformacion}
                setValidarConyugue={setValidarConyugue}
                setInfoClienteGrabada={setInfoClienteGrabada}
              />
              {validarConyugue ? (
                <FormInformacionConyugue idCliente={idClienteAux} />
              ) : (
                <h2></h2>
              )}
              {infoClienteGrabada.infoCliente ? (
                <>
                  <FormInformacionUbicabilidad
                    idCliente={idClienteAux}
                    tipoDireccion="DIRDOM"
                    setInfoClienteGrabada={setInfoClienteGrabada}
                  />
                  {!tieneContacto && (
                    <FormContactoCliente
                      idCliente={idClienteAux}
                      tipoDireccion="DIRDOM"
                    />
                  )}
                </>
              ) : (
                <Alert severity="warning">
                  <Typography>
                    Para continuar ingresa los datos del Cliente.
                  </Typography>
                </Alert>
              )}
            </TabPanel>
          )}

          <TabPanel value={valueCli} index={1}>
            <Alert severity="info">
              <Typography
                sx={{
                  fontSize: "1.2rem",
                }}
              >
                En esta sección recuerda tener a la mano tu celular y tu cédula.
              </Typography>
            </Alert>
            {infoGrabada.cliente ? (
              archivoFirmaFoto ? (
                <BoxDocumentosCliente
                  idCli={idClienteAux}
                  cliente={clienteConsultado}
                  identifCliente={identificacion}
                  idSolicitudChanger={setIdSolicitud}
                  setInfoGrabada={setInfoGrabada}
                  registroFirmaFoto={registroFirmaFoto}
                  setArchivoFirmaFoto={setArchivoFirmaFoto}
                />
              ) : generaLink ? (
                <>
                  <BoxGenerarLinkFirma
                    idCli={idClienteAux}
                    cliente={clienteConsultado}
                    identifCliente={identificacion}
                    idSolicitudChanger={setIdSolicitud}
                    setInfoGrabada={setInfoClienteGrabada}
                    infoGrabada={infoGrabada}
                  />
                  {infoGrabada.firma && (
                    <Box
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                    >
                      <SCSGenericButton
                        titulo={"Vista previa documentos"}
                        onClick={handleSeeDocs}
                      />
                    </Box>
                  )}
                </>
              ) : (
                <>
                  <TabFirmaFotoCliente
                    idCli={idClienteAux}
                    cliente={clienteConsultado}
                    identifCliente={identificacion}
                    idSolicitudChanger={setIdSolicitud}
                    setInfoGrabada={setInfoClienteGrabada}
                    infoGrabada={infoGrabada}
                    inhabilitar={false}
                  />
                  {infoGrabada.firma && (
                    <Box
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                    >
                      <SCSGenericButton
                        titulo={"Vista previa documentos"}
                        onClick={handleSeeDocs}
                      />
                    </Box>
                  )}
                </>
              )
            ) : (
              <Alert severity="error">
                <Typography>
                  Para continuar debe ingresar los datos de Cliente
                </Typography>
              </Alert>
            )}
          </TabPanel>
          {(flujoFinal !== "EXPRESS" || cambioCupo) && (
            <TabPanel value={valueCli} index={2}>
              {infoGrabada.firma ? (
                <FormClienteActividadEconomica
                  idCliente={idClienteAux}
                  setInfoClienteGrabada={setInfoClienteGrabada}
                />
              ) : (
                <Alert severity="error">
                  <Typography>
                    Para continuar debe registrar firma y fotografías.
                  </Typography>
                </Alert>
              )}
              {flujoFinal !== "EXPRESS" &&
                (infoClienteGrabada.financiero ? (
                  <FormClienteReferencias
                    idCliente={idClienteAux}
                    setInfoClienteGrabada={setInfoClienteGrabada}
                  />
                ) : (
                  <Alert severity="warning">
                    <Typography>
                      Para continuar ingresa tu Información Financiera.
                    </Typography>
                  </Alert>
                ))}
            </TabPanel>
          )}
          <TabPanel value={valueCli} index={3}>
            {infoGrabada.financiero && infoGrabada.firma ? (
              <>
                <FormInfoSolicitud
                  idCli={idClienteInformacion}
                  cliente={clienteConsultado}
                  identifCliente={identificacion}
                  idSolicitudChanger={setIdSolicitud}
                  setInfoGrabada={setInfoGrabada}
                  esRegistro={esRegistro}
                  flujoFinal={flujoFinal}
                  cambioCupo={cambioCupo}
                  datosMontoSugerido={datosPreevaluacion.datosMontoSugerido}
                  setUsaDebitoCuenta={setUsaDebitoCuenta}
                  usaDebitoCuenta={usaDebitoCuenta}
                />
                {usaDebitoCuenta && (
                  <FormDebitoCuenta
                    idCliente={idClienteInformacion}
                    idGrupo={authUser.usuarioFlujos[0].idGrupo}
                    idCuenta={null}
                    notificar={false}
                  />
                )}
              </>
            ) : (
              <Alert severity="error">
                <Typography>Para continuar debe completar</Typography>
                {!infoClienteGrabada.infoCliente && (
                  <Typography>-Información de Cliente</Typography>
                )}
                {!infoClienteGrabada.ubicabilidad && (
                  <Typography>-Dirección del Cliente</Typography>
                )}
                {!infoGrabada.firma && (
                  <Typography>-Firma y Fotografías</Typography>
                )}
                {!infoGrabada.financiero && (
                  <Typography>-Informacion Financiera</Typography>
                )}
                {!infoClienteGrabada.referencias && (
                  <Typography>-Referencias</Typography>
                )}
              </Alert>
            )}
          </TabPanel>

          <Stack direction="row" justifyContent="center">
            <SCSGenericButton
              size={18}
              titulo="Siguiente -->>"
              onClick={() => {
                if (flujoFinal === "EXPRESS" && !cambioCupo) {
                  setValueCli(valueCli + 2);
                } else {
                  setValueCli(valueCli + 1);
                }
              }}
              //  hidden={valueCli===5?true:false}
              disabled={!habilitarSiguiente}
            />
          </Stack>

          <Dialog
            open={openImagenFinal}
            onClose={handleCloseImagenFinal}
            fullWidth={true}
            maxWidth={"lg"}
          >
            <DialogContent>
              <Box
                component="img"
                src={`${process.env.REACT_APP_IMAGES_PATH}/solicitudFinal-${authUser.usuarioFlujos[0].idGrupo}.png`}
                sx={{
                  justifyContent: "center",
                  width: 941,
                  height: 529,
                }}
              />
            </DialogContent>
            <DialogActions>
              <Button onClick={handleCloseImagenFinal}>Cerrar</Button>
            </DialogActions>
          </Dialog>
        </div>
      )}
    </>
  );
};

export default StepInformacionCredito;
